import {
    USER_PREFERENCE, USER_NAVIGATING_CONFRIM_POPUP
} from '../actions/commonAction';


const initialState = {
    pagePreference: {
        "journal_is_grid": true,
        "feed_is_grid": true,
        "groups_active_is_grid": true,
        "groups_archive_is_grid": true,
        "shared_is_grid": true
    }
}

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_PREFERENCE:
            return {
                ...state,
                pagePreference: action.data
            }
        case USER_NAVIGATING_CONFRIM_POPUP:
            return {
                ...state,
                userNavigatingConfrimPopup: action.data
            }
        default:
            return state;
    }
};

export default commonReducer;
